import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

import { muiThemeLuma } from 'themes';

interface Props extends SvgIconProps {
  fill?: string;
}

const IconAllUnhecked: React.FC<Props> = ({ fill, ...other }) => (
  <SvgIcon width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...other}>
    <rect
      x="1"
      y="1"
      width="17"
      height="17"
      rx="1"
      stroke={muiThemeLuma.custom.palette.colorSupportPowder}
      strokeWidth="2"
    />
  </SvgIcon>
);

export default IconAllUnhecked;
